import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { authApi } from '@/api/auth';
import { useAuthStore } from '@/store/auth';

export function SSOCompletePage() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuthStore();

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      setError('Missing SSO code. Please try logging in again.');
      return;
    }

    authApi
      .ssoExchange(code)
      .then((data) => {
        login(
          {
            id: data.user.id,
            client_id: data.user.client_id,
            email: data.user.email,
            full_name: data.user.full_name,
            role: data.user.role,
            is_active: data.user.is_active,
            last_login: data.user.last_login,
          },
          data.access_token,
          data.refresh_token
        );
        navigate('/dashboard', { replace: true });
      })
      .catch(() => {
        setError('SSO authentication failed. The code may have expired. Please try again.');
      });
  }, [searchParams, login, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-mono-950 flex items-center justify-center py-12 px-4">
        <div className="max-w-sm w-full text-center">
          <h1 className="text-xl font-bold text-mono-100 tracking-[0.3em] font-orbitron mb-6">
            ARGOS
          </h1>
          <div className="border border-red-500/30 bg-red-500/10 p-4 mb-6">
            <p className="text-xs text-red-400 tracking-wider">{error}</p>
          </div>
          <Link
            to="/login"
            className="text-xs text-cyan-400 hover:text-cyan-300 tracking-wider"
          >
            BACK TO LOGIN
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-mono-950 flex items-center justify-center">
      <div className="text-center">
        <div className="w-6 h-6 border-2 border-cyan-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-xs text-mono-500 tracking-widest">COMPLETING SIGN IN...</p>
      </div>
    </div>
  );
}
